import React from "react";
import { useInViewOnce } from "../hooks/useInViewOnce";

/** Load the first N tiles eagerly; defer image requests for off-screen rows until near viewport. */
export const GALLERY_GRID_PRIORITY_COUNT = 16;

/**
 * Wrapper for portfolio-style grid cells: keeps layout (aspect) stable while deferring `img` src.
 */
export function GalleryImageTile({
  idx,
  className,
  onClick,
  childrenWhenVisible,
  pendingClassName = "gallery-grid-tile-pending",
}) {
  const [ref, show] = useInViewOnce({
    skip: idx < GALLERY_GRID_PRIORITY_COUNT,
    rootMargin: "320px 0px",
  });

  return (
    <div ref={ref} className={className} onClick={onClick}>
      <div className="card-content">
        {show ? childrenWhenVisible() : <div className={pendingClassName} aria-hidden />}
      </div>
    </div>
  );
}
